import { get, isFunction } from 'lodash';
import * as z from 'zod';
import * as ba from './base';
import { isComponentContext, assertComponentContext } from '../helpers';
import { MODAL_RESULT_SCHEMA } from './modal';
import { isComponentValueCache } from '../caching';
export class CloseComponentAction extends ba.Action {
    static get manifest() {
        return {
            name: 'closeComponent',
            schema: z.object({ result: MODAL_RESULT_SCHEMA }).optional()
        };
    }
    async handle(event, args) {
        const component = event.component;
        if (isComponentContext(component)) {
            if (component.isModalComponent && component.modalName) {
                return component.$imodal.close(component.modalName, (args ? args.result : null) || { cancel: true });
            }
            else {
                const fn = get(component, '$tabs.close');
                if (isFunction(fn)) {
                    fn();
                }
            }
        }
    }
}
export class ReloadComponentDataAction extends ba.Action {
    static get manifest() {
        return {
            name: 'reloadComponentData',
            schema: z
                .object({
                value: z.string().optional()
            })
                .optional()
        };
    }
    async handle(event, args) {
        const component = event.component;
        assertComponentContext(component);
        if (args?.value) {
            component.loadData(args?.value);
        }
        else {
            component.loadData();
        }
    }
}
export class SetDataAction extends ba.Action {
    static get manifest() {
        return {
            name: 'setData',
            schema: z.object({
                path: z.string(),
                value: z.any(),
                resolve: z
                    .boolean()
                    .optional()
                    .default(false),
                noTouchLastLoaded: z
                    .boolean()
                    .optional()
                    .default(false),
                noTakeSnapshot: z
                    .boolean()
                    .optional()
                    .default(false)
            })
        };
    }
    async handle(event, args) {
        const component = event.component;
        assertComponentContext(component);
        let value = args.resolve ? Promise.resolve(args.value) : args.value;
        component.setData(args.path, value, {
            noTouchLastLoaded: args.noTouchLastLoaded || false,
            noTakeSnapshot: args.noTakeSnapshot || false
        });
    }
}
export class CacheAction extends ba.Action {
    static get manifest() {
        return {
            name: 'cache',
            schema: z.object({
                path: z.string()
            })
        };
    }
    async handle(event, args) {
        const component = event.component;
        assertComponentContext(component);
        const handler = get(component, `$$cache_${args.path}`, null);
        if (isComponentValueCache(handler)) {
            await handler.persist(get(component, args.path));
        }
    }
}
export class ClearCacheAction extends ba.Action {
    static get manifest() {
        return {
            name: 'clearCache',
            schema: z.object({
                path: z.string()
            })
        };
    }
    async handle(event, args) {
        const component = event.component;
        assertComponentContext(component);
        const handler = get(component, `$$cache_${args.path}`);
        if (isComponentValueCache(handler)) {
            await handler.clearCache();
        }
    }
}
//# sourceMappingURL=component.js.map